import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import { Helmet } from "react-helmet"

export default ({ data }) => {
    const appdata = data.projectdataJson
    return (
        <Layout>
            <section id="portfolio" className="two">
                <div className="container">
                    <div className="row">
                        <div className="col-4 col-12-mobile">

                            <header>
                                <h2>{appdata.title}</h2>
                            </header>

                            <img src={appdata.image} alt={appdata.title} className="small _thumb" />

                            <br />

                            <a href={appdata.link} target="_blank" rel="noopener noreferrer"
                                className="button scrolly">Download</a>
                        </div>

                        <div className="col-8 col-12-mobile">
                            <br />
                            <br />
                            <p className={"line-text"}>{appdata.desc.split("\n").map(function (item, key) {
                                return (
                                    <span key={key} >
                                        {item}
                                        <br />
                                    </span>
                                )
                            })}</p>
                        </div>
                    </div>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>{appdata.title}</title>
                        <link rel="canonical" href={"https://naxrohan.github.io/" + appdata.page} />
                    </Helmet>
                </div>
            </section>
        </Layout>
    )
}

export const query = graphql`
  query($slug: String!) {
    projectdataJson(page: {eq: $slug}) {
        title
        page
        link
        image
        desc
    }
  }
`
